import {IReportItemComponent} from '../../models/i-report-item-component';
import { Component, OnInit } from '@angular/core';
import { ScaleResultsSectionsListComponent } from '../scale-results-sections-list/scale-results-sections-list.component';
import { AssessmentResult } from "../../../shared/models/assessment-result";
import { Variable } from "../../models/variable";

@Component({
  selector: 'app-addo-scale-results',
  templateUrl: './addo-scale-results.component.html'
})
export class AddoScaleResultsComponent extends ScaleResultsSectionsListComponent implements OnInit, IReportItemComponent {
  private _scales_per_page:number;
  private _pageBreaks:number[];
  private _skipGraph:boolean;
  private _skipContent:boolean;
  private _skipTable:boolean;

  constructor() { 
    super()
    this._pageBreaks = [];
    this._skipTable = false;
    this._skipContent = false;
    this._skipGraph = false;
  }

  ngOnInit() {
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
  }


  get SkipContent() : boolean {
    return this._skipContent;
  }

  get SkipGraph() : boolean {
    return this._skipGraph;
  }

  get SkipTable() : boolean {
    return this._skipTable;
  }


  public getHTMLClassNames() : string[] {
    return ["scale-results", "report-item-component", "flex-column"];
  }

  public setReportData(data:any, results:AssessmentResult[], variables:Variable[]) {
    super.setReportData(data, results, variables);
    if (data && data.scales_per_page) {
      this._scales_per_page = +data.scales_per_page;
    }
    else if (this.ScaleResults) {
      // this makes it so we never force a page break here.
      this._scales_per_page = this.ScaleResults.length + 1;
    }
    else {
      console.error("No scales found for component");
      this._scales_per_page = 0;
    }

    if (data.pageBreaks && data.pageBreaks.length > 0) {
      this._pageBreaks = data.pageBreaks.map(pb => +pb).filter(pb => !isNaN(pb));
    }
    else {
      this._pageBreaks = [];
    }

    if (data) {
      this._skipTable = data.skipTable == true;
      this._skipGraph = data.skipGraph == true;
      this._skipContent = data.skipContent == true;
    }

  }

  // shouldPrintBreak(0), showPageHeader(0), scales_per_page = 2
  // index=0: false, false -> should be false, false
  // index=1: true, true  -> should be true, false
  // index=2: false, false -> should be false, true

  // shouldPrintBreak(0), showPageHeader(0), scales_per_page = 2, scales_per_page=3
  // index=0: false, false => should be false, false
  // index=1: false, false => should be false, false
  // index=2: true, true, should be true, false
  // index=3: false, false -> should be false, true

  public showPageHeader(index:number) {
    if (index == 0) {
      return false;
    }

    if (this._pageBreaks && this._pageBreaks.length > 0) {
      return this._pageBreaks.indexOf(index) >= 0;
    }
    
   // since index is 0 based the the user scales per page is 1 based we convert.
    let pageBreakIndex = (index + 1) - this._scales_per_page;
    if (index < 0) {
      return false;
    }
    else if (index % this._scales_per_page == 0) {
      return true;
    }
    else {
      return false;
    }
  }

  get ScalesPerPage() {
    return this._scales_per_page;
  }

  get IsSingleScaleResult() {
    let isSingle = this.ScaleResults && this.ScaleResults.length == 1;
    return isSingle;
  }

  get SingleScaleResult() {
    if (this.ScaleResults && this.ScaleResults[0]) {
      return this.ScaleResults[0];
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/addo-scale-results/addo-scale-results.component.ts